import React, { useEffect, useState } from 'react';
import { Modal } from '@/types/modal';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import { ValueButton } from '@/components/atoms/Section';
import ModalView from '@/components/modals/Modal';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useCheckUpdatePermission, useDocument } from '@/hooks/documents';
import Styles from './Document.module.scss';

const DocumentView: React.FC = () => {
  const [releaseNoteModal, setReleaseNoteModal] = useState<Modal | null>(null);
  const [guidanceModal, setGuidanceModal] = useState<Modal | null>(null);
  const { t } = useTranslation();
  const [canUserUpdateDocuments, setCanUserUpdateDocuments] = useState(false);
  const checkPermissionR = useCheckUpdatePermission();
  const getReleaseNote = useDocument('release-notes');
  const getUserGuide = useDocument('user-guide');

  const openDocument = function (url: string) {
    window.open(url, '_blank');
  };

  useEffect(() => {
    if (checkPermissionR.kind === 'Loaded') {
      setCanUserUpdateDocuments(checkPermissionR.data.canEdit);
    }
  }, [checkPermissionR.kind]);

  const handleOpen = (type: string) => {
    switch (type) {
      case 'release-notes':
        if (getReleaseNote.kind === 'Loaded') {
          openDocument(getReleaseNote.data.documentUrl);
        }
        break;
      case 'user-guide':
        if (getUserGuide.kind === 'Loaded') {
          openDocument(getUserGuide.data.documentUrl);
        }
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', justifyContent: 'center', gap: '20px', alignItems: 'start' }}>
      <Box className={Styles.documentBox}>
        <Box className={Styles.displayDocumentBox}>
          <TipsAndUpdatesOutlinedIcon
            className={Styles.iconClickable}
            onClick={() => handleOpen('release-notes')}
          />
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{ fontSize: 14, cursor: 'pointer' }}
            onClick={() => handleOpen('release-notes')}
          >
            {t('header.release_note')}
          </Typography>
        </Box>

        {canUserUpdateDocuments && (
          <Box sx={{ ml: '0.25rem' }}>
            <ValueButton
              label="UPDATE"
              onClick={() =>
                setReleaseNoteModal({
                  kind: 'DocumentUpload',
                  type: 'release-notes',
                  onClose: () => setReleaseNoteModal(null),
                })
              }
            />
          </Box>
        )}
        <ModalView modal={releaseNoteModal} />
      </Box>
      <Box className={Styles.documentBox}>
        <Box className={Styles.displayDocumentBox}>
          <MenuBookIcon
            className={Styles.iconClickable}
            onClick={() => handleOpen('user-guide')}
          />
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{ fontSize: 14, cursor: 'pointer' }}
            onClick={() => handleOpen('user-guide')}
          >
            {t('header.guidance')}
          </Typography>
        </Box>

        {canUserUpdateDocuments && (
          <Box sx={{ ml: '1.75rem' }}>
            <ValueButton
              label="UPDATE"
              onClick={() =>
                setGuidanceModal({
                  kind: 'DocumentUpload',
                  type: 'user-guide',
                  onClose: () => setGuidanceModal(null),
                })
              }
            />
          </Box>
        )}
        <ModalView modal={guidanceModal} />
      </Box>
    </Box>
  );
};

export default DocumentView;
